<app-avatar size="lg" [src]="previewUrl() ?? currentUrl()" [name]="name()" [seed]="seed()" [fallback]="fallback()" />

<input #fileInput type="file" accept="image/*" class="hidden" (change)="onSelected($event)" />
<button
  type="button"
  (click)="fileInput.click()"
  [disabled]="disabled()"
  class="px-3 py-1.5 text-sm whitespace-nowrap bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed text-gray-800 font-medium rounded-md hover:bg-gray-300 transition-colors"
>
  {{ previewUrl() || currentUrl() ? 'Upload new avatar' : 'Upload avatar' }}
</button>

@if (error(); as message) {
  <div class="max-w-48 text-center text-sm text-red-600">{{ message }}</div>
}
